export enum ProviderType {
  NONE = 'NONE',
  DISABLED = 'DISABLED',
  PAYPAL = 'PAYPAL',
  PAYONEER = 'PAYONEER',
}

export const AVAILABLE_PROVIDER_TYPE = Object.keys(ProviderType);

class PaymentExtProvider {
  public readonly providerType: ProviderType;
  constructor({ providerType }: { providerType: ProviderType }) {
    this.providerType = providerType;
  }

  public static fromJSON = (value: any) => {
    const { current_ext_provider, ext_provider_datas } = Object.assign({}, value);
    const providerType = current_ext_provider
      ? String(current_ext_provider).toUpperCase()
      : Object.keys(ext_provider_datas).length === 0
      ? ProviderType.NONE
      : ProviderType.DISABLED;

    if (providerType && !AVAILABLE_PROVIDER_TYPE.includes(providerType))
      throw new TypeError('.current_ext_provider must be a valid action string');

    return new PaymentExtProvider({
      providerType: providerType as ProviderType,
    });
  };
}

export default PaymentExtProvider;
